<template>
	<div class="_modal bg-white">
		<div
			class="
				_modal__content
				md-down:px-4
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/email_parent.svg"
					alt="Luca Education"
					title="Luca Education"
					height="150"
					width="150"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
					text-center
				"
			>
				Gửi thông báo học phí
			</div>
			<div class="w-full mt-5">
				<div class="input-group grid grid-cols-2 items-center">
					<div
						class="
							text-sm
							text-neutral-500
							uppercase
							font-medium
						"
					>
						ĐỐI TƯỢNG
					</div>
					<div class="font-bold text-neutral-500 truncate">
						{{ notification.name }}
					</div>
				</div>
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="
							text-sm
							text-neutral-500
							uppercase
							font-medium
						"
					>
						Tiêu đề
					</div>
					<div class="font-bold text-neutral-500 truncate">
						{{ notification.title }}
					</div>
				</div>
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="
							text-sm
							text-neutral-500
							uppercase
							font-medium
						"
					>
						Thành tiền
					</div>
					<div class="font-bold text-neutral-500 truncate">
						{{ $filters.priceFormat(notification.money) }}
					</div>
				</div>
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="
							text-sm
							text-neutral-500
							uppercase
							font-medium
						"
					>
						Người gửi
					</div>
					<div class="font-bold text-neutral-500 truncate">
						{{ notification.sender }}
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Quay lại
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="$emit('submit')"
				:disabled="inProgress"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ConfirmSendFeeNotice',

	props: {
		notification: {
			type: Object,
			required: true,
		},
		inProgress: {
			type: Boolean,
			required: true,
		}
	},
};
</script>
